@if (
  status_and_dates.sequence &&
  status_and_dates.sequence.statuses &&
  status_and_dates.sequence.statuses.length > 0
  ) {
  <div
    class="timeline-container"
    >
    @if (!isMobile) {
      <div>
        <div class="row align-top">
          <div class="col-md-1"></div>
          <div class="col-md-11">
            <ul class="status-sequence">
              @for (detail of status_and_dates.sequence.statuses; track detail) {
                <li
                  class="status"
                  >
                  <span
                    class="status__summary-text status-name"
              [ngClass]="
                status_and_dates.activeStatusIndex === detail.index &&
                status_and_dates.sequence.active
                  ? 'status__summary-text--active'
                  : ''
              "
                    >{{ detail.status.name }}</span
                    >
                  </li>
                }
              </ul>
            </div>
          </div>
          <bubble-line
            [items]="status_and_dates.sequence.statuses"
            [current]="status_and_dates.activeStatusIndex"
            [notActive]="!status_and_dates.sequence.active"
            [readOnly]="!status_and_dates.sequence.active || dispositions"
            (moveStatus)="changeStatus($event)">
          </bubble-line>
          <div class="row">
            <div class="col-md-1">
              <span class="date-type-header">Actual/Target</span>
            </div>
            <div class="col-md-11">
              <ul
                class="status-sequence actual-row"
                [class.edit-mode]="isEditMode"
                [style.margin-bottom]="isEditMode ? '50px' : '10px'">
                @for (detail of status_and_dates.statusDates; track detail; let i = $index) {
                  <li
                    class="status"
                    >
                    @if (detail.dates && (!isEditMode || !sequencePermissions)) {
                      <span
                        class="status__summary-text actual-row"
                        >
                        <span class="date-row">
                          {{ detail.dates.date }}
                          @if (detail.dates.isTarget) {
                            <mat-icon
                              matTooltip="Target Date"
                              class="target-date">
                              flare
                            </mat-icon>
                          }
                          @if (detail.dates.isTarget === false) {
                            <mat-icon
                              matTooltip="Actual Date"
                              class="actual-date">
                              check_circle
                            </mat-icon>
                          }
                        </span>
                      </span>
                    }
                    @if (isEditMode && sequencePermissions) {
                      <span
                        class="status__summary-text actual-row picker">
                        <mat-form-field appearance="fill" class="date-picker">
                          <input
                            matInput
                            [matDatepicker]="picker"
                            [value]="detail.dates.newDate"
                            (dateChange)="changeDate($event, detail, i, false)" />
                          <mat-datepicker-toggle
                            matIconSuffix
                          [for]="picker"></mat-datepicker-toggle>
                          <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>
                        @if (detail.dates.dateID || detail.dates.newDate) {
                          <mat-icon
                            color="warn"
                            style="cursor: pointer"
                            matTooltip="Delete Date"
                            (click)="deleteDateConfirmation(detail, false)">
                            clear
                          </mat-icon>
                        }
                        <div class="row">
                          <div class="col-md-12">
                            @if (detail.dates.dateID || detail.dates.newDate) {
                              <mat-checkbox
                                [(ngModel)]="detail.dates.newIsTarget"
                                [checked]="detail.dates.newIsTarget"
                                [disabled]="disableTargetCheckBox(detail.dates)">
                                Target Date
                              </mat-checkbox>
                            }
                          </div>
                        </div>
                      </span>
                    }
                  </li>
                }
              </ul>
            </div>
          </div>
          <div class="row">
            <div class="col-md-1">
              <span class="date-type-header initial-row">Initial</span>
            </div>
            <div class="col-md-11">
              <ul
                class="status-sequence"
                [style.margin-bottom]="isEditMode ? '60px' : '10px'"
                [style.margin-top]="isEditMode ? '10px' : '0'">
                @for (detail of status_and_dates.statusDates; track detail; let i = $index) {
                  <li
                    class="status"
                    >
                    @if (
                      detail.dates &&
                      detail.dates.initialDate &&
                      (!isEditMode ||
                      !sequencePermissions ||
                      !hasInitialValidation(detail.dates.initialDate))
                      ) {
                      <span
                        class="status__summary-text initial-row"
                        >{{ detail.dates.initialDate }}</span
                        >
                      }
                      @if (
                        isEditMode &&
                        sequencePermissions &&
                        hasInitialValidation(detail.dates.initialDate)
                        ) {
                        <span
                          class="status__summary-text actual-row picker">
                          <mat-form-field appearance="fill" class="date-picker">
                            <input
                              matInput
                              [matDatepicker]="picker"
                              [value]="detail.dates.newInitialDate"
                              (dateChange)="changeDate($event, detail, i, true)" />
                            <mat-datepicker-toggle
                              matIconSuffix
                            [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                          </mat-form-field>
                          @if (
                            detail.dates.initialDateID || detail.dates.newInitialDate
                            ) {
                            <mat-icon
                              color="warn"
                              style="cursor: pointer"
                              matTooltip="Tabular View"
                              (click)="deleteDateConfirmation(detail, true)"
                              >clear</mat-icon
                              >
                            }
                          </span>
                        }
                      </li>
                    }
                  </ul>
                </div>
              </div>
              @if (status_and_dates.sequence.name === 'Closing') {
                <div class="row">
                  <div class="col-md-1">
                    <span class="date-type-header initial-row">Forecasts</span>
                  </div>
                  <div class="col-md-11">
                    <ul
                      class="status-sequence"
                      [style.margin-bottom]="isEditMode ? '60px' : '10px'"
                      [style.margin-top]="isEditMode ? '10px' : '0'">
                      @for (detail of status_and_dates.statusDates; track detail; let i = $index) {
                        <li
                          class="status"
                          >
                          @if (
                            detail.forecastDates ||
                            !permissions.forecastApprovalDateTypePermissions._edit
                            ) {
                            <span
                              class="status__summary-text initial-row"
                              >
                              {{ detail.forecastDates.date }}
                            </span>
                          }
                          @if (
                            isEditMode &&
                            permissions.forecastApprovalDateTypePermissions._edit
                            ) {
                            <span
                              class="status__summary-text actual-row picker">
                              <mat-form-field appearance="fill" class="date-picker">
                                <input
                                  matInput
                                  [matDatepicker]="picker"
                                  [value]="detail.forecastDates.newDate"
                                  (dateChange)="changeForecastDate($event, detail, i)" />
                                <mat-datepicker-toggle
                                  matIconSuffix
                                [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                              </mat-form-field>
                              @if (
                                detail.forecastDates &&
                                (detail.forecastDates.id || detail.forecastDates.newDate)
                                ) {
                                <mat-icon
                                  color="warn"
                                  style="cursor: pointer"
                                  matTooltip="Delete Date"
                                  (click)="deleteForecastDateConfirmation(detail)">
                                  clear
                                </mat-icon>
                              }
                            </span>
                          }
                        </li>
                      }
                    </ul>
                  </div>
                </div>
              }
            </div>
          }
          @if (isMobile) {
            <div>
              <div class="row gutters">
                <div class="col-md-12">
                  @if (
                    !sequencePermissions || status_and_dates.isDead || dispositions
                    ) {
                    <span
                      >
                      <h4>Current Status:</h4>
                      {{ currentStatusName }}
                    </span>
                  }
                  @if (
                    sequencePermissions && !status_and_dates.isDead && !dispositions
                    ) {
                    <span
                      >
                      <h4>Current Status</h4>
                      <mat-form-field>
                        <mat-label>Select Status</mat-label>
                        <mat-select name="status" [(ngModel)]="currentStatus">
                          @for (status of status_and_dates.sequence.statuses; track status) {
                            <mat-option
                              [value]="status.status.id"
                              (click)="changeStatus(status)">
                              {{ status.status.name }}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </span>
                  }
                </div>
                <div class="col-md-6">
                  <h4>Actual/Target</h4>
                  <div class="mat-elevation-z8">
                    <table
                      mat-table
                      class="stripped-table"
                      #actualTable
                      [dataSource]="statusAndDatesDataSource"
                      matSort>
                      <!-- Status Column -->
                      <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef>Status</th>
                        <td mat-cell *matCellDef="let row; let i = index">
                          {{ row.statusName }}
                        </td>
                      </ng-container>
                      <!-- Date Column -->
                      <ng-container matColumnDef="date">
                        <th mat-header-cell *matHeaderCellDef>Date</th>
                        <td mat-cell *matCellDef="let row; let i = index">
                          @if (row.dates && !isEditMode) {
                            <span>
                              {{ row.dates.date }}
                              @if (row.dates.isTarget) {
                                <mat-icon
                                  matTooltip="Target Date"
                                  class="target-date">
                                  flare
                                </mat-icon>
                              }
                              @if (row.dates.isTarget === false) {
                                <mat-icon
                                  matTooltip="Actual Date"
                                  class="actual-date">
                                  check_circle
                                </mat-icon>
                              }
                            </span>
                          }
                          @if (isEditMode) {
                            <span>
                              <mat-form-field appearance="fill" class="date-picker-mobile">
                                <input
                                  matInput
                                  [matDatepicker]="picker"
                                  [value]="row.dates.newDate"
                                  (dateChange)="changeDate($event, row, i, false)" />
                                <mat-datepicker-toggle
                                  matIconSuffix
                                [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker touchUi #picker></mat-datepicker>
                              </mat-form-field>
                              @if (row.dates.dateID || row.dates.newDate) {
                                <mat-icon
                                  color="warn"
                                  style="cursor: pointer"
                                  matTooltip="Delete Date"
                                  (click)="deleteDateConfirmation(row, false)">
                                  clear
                                </mat-icon>
                              }
                              <div class="row">
                                <div class="col-md-12">
                                  @if (row.dates.dateID || row.dates.newDate) {
                                    <mat-checkbox
                                      [(ngModel)]="row.dates.newIsTarget"
                                      [checked]="row.dates.newIsTarget"
                                      >
                                      Target Date
                                    </mat-checkbox>
                                  }
                                </div>
                              </div>
                            </span>
                          }
                        </td>
                      </ng-container>
                      <tr mat-header-row *matHeaderRowDef="statusAndDatesColumns"></tr>
                      <tr
                        mat-row
                      *matRowDef="let row; columns: statusAndDatesColumns"></tr>
                    </table>
                  </div>
                </div>
                <div class="col-md-6">
                  <h4>Initial</h4>
                  <div class="mat-elevation-z8">
                    <table
                      mat-table
                      class="stripped-table"
                      #initialTable
                      [dataSource]="statusAndDatesDataSource"
                      matSort>
                      <!-- Status Column -->
                      <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef>Status</th>
                        <td mat-cell *matCellDef="let row; let i = index">
                          {{ row.statusName }}
                        </td>
                      </ng-container>
                      <!-- Date Column -->
                      <ng-container matColumnDef="date">
                        <th mat-header-cell *matHeaderCellDef>Date</th>
                        <td mat-cell *matCellDef="let row; let i = index">
                          @if (
                            row.dates &&
                            row.dates.initialDate &&
                            (!isEditMode ||
                            !hasInitialValidation(row.dates.initialDate))
                            ) {
                            <span
                              >
                              {{ row.dates.initialDate }}
                            </span>
                          }
                          @if (
                            isEditMode && hasInitialValidation(row.dates.initialDate)
                            ) {
                            <span
                              >
                              <mat-form-field appearance="fill" class="date-picker-mobile">
                                <input
                                  matInput
                                  [matDatepicker]="picker"
                                  [value]="row.dates.newInitialDate"
                                  (dateChange)="changeDate($event, row, i, true)" />
                                <mat-datepicker-toggle
                                  matIconSuffix
                                [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker touchUi #picker></mat-datepicker>
                              </mat-form-field>
                              @if (row.dates.initialDateID || row.dates.newInitialDate) {
                                <mat-icon
                                  color="warn"
                                  style="cursor: pointer"
                                  matTooltip="Tabular View"
                                  (click)="deleteDateConfirmation(row, true)"
                                  >clear</mat-icon
                                  >
                                }
                              </span>
                            }
                          </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="statusAndDatesColumns"></tr>
                        <tr
                          mat-row
                        *matRowDef="let row; columns: statusAndDatesColumns"></tr>
                      </table>
                    </div>
                  </div>
                  @if (status_and_dates.sequence.name === 'Closing') {
                    <div
                      class="col-md-6"
                      >
                      <h4>Forecasts</h4>
                      <div class="mat-elevation-z8">
                        <table
                          mat-table
                          class="stripped-table"
                          #initialTable
                          [dataSource]="statusAndDatesDataSource"
                          matSort>
                          <!-- Status Column -->
                          <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef>Status</th>
                            <td mat-cell *matCellDef="let row; let i = index">
                              {{ row.statusName }}
                            </td>
                          </ng-container>
                          <!-- Date Column -->
                          <ng-container matColumnDef="date">
                            <th mat-header-cell *matHeaderCellDef>Date</th>
                            <td mat-cell *matCellDef="let row; let i = index">
                              @if (
                                row.forecastDates &&
                                (!isEditMode ||
                                !permissions.forecastApprovalDateTypePermissions._edit)
                                ) {
                                <span
                                  >
                                  {{ row.forecastDates.date }}
                                </span>
                              }
                              @if (
                                isEditMode &&
                                permissions.forecastApprovalDateTypePermissions._edit
                                ) {
                                <span
                                  >
                                  <mat-form-field appearance="fill" class="date-picker-mobile">
                                    <input
                                      matInput
                                      [matDatepicker]="picker"
                                      [value]="row.forecastDates.newDate"
                                      (dateChange)="changeForecastDate($event, row, i)" />
                                    <mat-datepicker-toggle
                                      matIconSuffix
                                    [for]="picker"></mat-datepicker-toggle>
                                    <mat-datepicker touchUi #picker></mat-datepicker>
                                  </mat-form-field>
                                  @if (
                                    row.forecastDates &&
                                    (row.forecastDates.id || row.forecastDates.newDate)
                                    ) {
                                    <mat-icon
                                      color="warn"
                                      style="cursor: pointer"
                                      matTooltip="Tabular View"
                                      (click)="deleteForecastDateConfirmation(row)">
                                      clear
                                    </mat-icon>
                                  }
                                </span>
                              }
                            </td>
                          </ng-container>
                          <tr mat-header-row *matHeaderRowDef="statusAndDatesColumns"></tr>
                          <tr
                            mat-row
                          *matRowDef="let row; columns: statusAndDatesColumns"></tr>
                        </table>
                      </div>
                    </div>
                  }
                </div>
              </div>
            }
            <sub-statuses
              [currentStatus]="currentStatus"
              [statusSequence]="status_and_dates.sequence"
              [subsequences]="subsequences"
              [projectCredits]="projectCredits"
              [projectSubstatusDates]="projectSubstatusDates"
            [projectSubstatuses]="projectSubstatuses"></sub-statuses>
          </div>
        }
